import { summaryText } from '../content/articleModel'
import { CONTENT_DATES } from '../content/dates'
import { CONTENT_PAGES } from '../content/generated/pages'
import { contentFaq } from '../content/text'
import { RegistryEntry, ReviewMetadata } from '../types'

/** Fresh, empty review block for content that has not been written or reviewed yet. */
export const unreviewed = (): ReviewMetadata => ({ references: [], reviewStatus: 'draft' })

/** Publish only approved Part B source records; unknown future seeds remain drafts. */
export const approvedContent = <T extends RegistryEntry>(entry: T): T => {
  const page = CONTENT_PAGES[entry.slug]
  if (!page) return entry
  return {
    ...entry,
    published: true,
    title: page.title,
    metaDescription: page.description,
    shortAnswer: summaryText(page),
    faq: contentFaq(page.faq),
    review: {
      reviewStatus: 'approved',
      reviewer: 'carlos-seraphim',
      ...CONTENT_DATES[entry.slug],
      references: page.sources
    }
  }
}
